module.exports = __webpack_public_path__ + "static/media/Firefox_logo.4f46aaab.svg";